import { render, staticRenderFns } from "./latest-message.vue?vue&type=template&id=0c557e45&"
import script from "./latest-message.js?vue&type=script&lang=js&"
export * from "./latest-message.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports